export enum Direction {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
  TopLeft = 'top-left',
  BottomLeft = 'bottom-left',
}
